import { Circle, Diamond } from "lucide-react";

interface StatusIconProps {
  status: string;
  className?: string;
}

export const StatusIcon = ({ status, className = "h-4 w-4" }: StatusIconProps) => {
  switch (status) {
    case "Open":
      return <Circle className={`${className} fill-current text-gray-400`} />;
    case "Pending":
      return <Diamond className={`${className} fill-current text-orange-500`} />;
    case "Closed":
      return <Circle className={`${className} fill-current text-green-500`} />;
    default:
      return <Circle className={`${className} fill-current text-gray-400`} />;
  }
};